module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 50px"
    }
  }, [(!_vm.show) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h1', [_vm._v("You currently have no items in cart")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "1.17em",
      "border": "1px solid transparent",
      "background": "#4DCC2F",
      "padding": "0.75em 1em",
      "border-radius": "1.5em",
      "color": "#fff"
    },
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Start Shopping!")])], 1) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("My Cart")]) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    staticStyle: {
      "display": "block",
      "overflow": "hidden",
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_vm._v("Options")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return (_vm.show) ? _c('item', {
      key: item.code,
      attrs: {
        "item": item
      },
      on: {
        "increment": function($event) {
          _vm.incrementTotal($event)
        },
        "decrement": function($event) {
          _vm.decrementTotal($event)
        },
        "additem": function($event) {
          _vm.additem($event)
        },
        "removeitem": function($event) {
          _vm.removeitem($event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('strong', [_vm._v("Total Items")]), _vm._v(" " + _vm._s(_vm.total) + " \n\t\t\t"), _c('strong', [_vm._v("Total Price")]), _vm._v(" Php " + _vm._s(_vm.formatMoney(_vm.price)) + " \n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding": "0px 15px",
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "button-type-e",
    on: {
      "click": _vm.placeOrder
    }
  }, [_vm._v("Place Order")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notification) ? _c('notification', {
    on: {
      "endtransaction": _vm.endtransaction
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notificationb) ? _c('notification-b', {
    attrs: {
      "nbc": _vm.nbc,
      "nbm": _vm.nbm
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notificationS) ? _c('notification-s') : _vm._e()], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50d9a010"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart.vue
// module id = 152
// module chunks = 0